/**
 * Curated dates worth themeing a challenge around. Matched year-agnostically by month + day.
 * Floating holidays use the originally-supplied 2025 calendar dates — close enough to surface
 * the banner; admins can ignore or override.
 */
const SPECIAL_DAYS = [
    { month: 1,  day: 1,  name: "New Year's Day" },
    { month: 1,  day: 20, name: 'Martin Luther King Jr. Day' },
    { month: 1,  day: 29, name: 'Lunar New Year' },
    { month: 2,  day: 9,  name: 'Pizza Day' },
    { month: 2,  day: 14, name: "Valentine's Day" },
    { month: 2,  day: 17, name: "Presidents' Day" },
    { month: 3,  day: 17, name: "St. Patrick's Day" },
    { month: 3,  day: 20, name: 'First Day of Spring' },
    { month: 4,  day: 1,  name: "April Fools' Day" },
    { month: 4,  day: 20, name: 'Easter' },
    { month: 4,  day: 22, name: 'Earth Day' },
    { month: 5,  day: 4,  name: 'Star Wars Day' },
    { month: 5,  day: 5,  name: 'Cinco de Mayo' },
    { month: 5,  day: 11, name: "Mother's Day" },
    { month: 5,  day: 26, name: 'Memorial Day' },
    { month: 6,  day: 1,  name: 'Pride Month Begins' },
    { month: 6,  day: 8,  name: 'Best Friends Day' },
    { month: 6,  day: 15, name: "Father's Day" },
    { month: 6,  day: 21, name: 'First Day of Summer' },
    { month: 7,  day: 4,  name: 'Independence Day' },
    { month: 7,  day: 17, name: 'World Emoji Day' },
    { month: 7,  day: 30, name: 'International Friendship Day' },
    { month: 8,  day: 8,  name: 'International Cat Day' },
    { month: 8,  day: 19, name: 'World Photography Day' },
    { month: 9,  day: 1,  name: 'Labor Day' },
    { month: 9,  day: 13, name: 'Positive Thinking Day' },
    { month: 9,  day: 22, name: 'First Day of Fall' },
    { month: 10, day: 1,  name: 'International Coffee Day' },
    { month: 10, day: 5,  name: "World Teachers' Day" },
    { month: 10, day: 31, name: 'Halloween' },
    { month: 11, day: 3,  name: 'Sandwich Day' },
    { month: 11, day: 11, name: 'Veterans Day' },
    { month: 11, day: 27, name: 'Thanksgiving' },
    { month: 11, day: 28, name: 'Black Friday' },
    { month: 12, day: 1,  name: 'Holiday Season Begins' },
    { month: 12, day: 4,  name: 'Cookie Day' },
    { month: 12, day: 24, name: 'Christmas Eve' },
    { month: 12, day: 25, name: 'Christmas' },
    { month: 12, day: 31, name: "New Year's Eve" },
];

/** `dateLike` may be a Date, ISO string, or datetime-local string. Returns null if invalid. */
export function getSpecialDay(dateLike) {
    if (!dateLike) return null;
    const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
    if (Number.isNaN(d.getTime())) return null;
    const month = d.getMonth() + 1;
    const day = d.getDate();
    return SPECIAL_DAYS.find(s => s.month === month && s.day === day)?.name ?? null;
}
